import React, { useState, useEffect, useContext } from 'react';
import Inputs from 'components/inputs/inputs';
import Flow from 'components/common/flow/flow';
import Panel from 'components/common/panel/panel';
import FlexibleRow from 'components/common/flexibleRow/flexibleRow';
import Heading from 'components/common/heading/heading';
import AppContext from 'contexts/appContext';
import moment from 'moment';

import TestDataHdr from './dataHdr';

export default function MenuUpdatePage() {
  const { setAppArea, setAppBreadcrumb } = useContext(AppContext);

  const [showMoreVisible, setShowMoreVisible] = useState(true);

  useEffect(() => {
    setAppArea(AppContext.Areas.MenuUpdate, 'Update History');
    setAppBreadcrumb([{ name: 'Home', href: '/' }, { name: 'QuickMenu Update', selected: true }]);
  }, []);

  const renderRows = () => {
    if (TestDataHdr && TestDataHdr.length === 0) {
      return <div>No updates found.</div>;
    }
    return TestDataHdr && TestDataHdr.map((item, index) => MenuUpdateRow(item, index));
  };

  return (
    <Flow>
      <Flow.Header>
        <Heading>
          Enterprise
        </Heading>
      </Flow.Header>

      <Flow.Body>
        <div className='row justify-content-md-center mx-0 mt-4'>
          <div className='col-12 col-md-10 col-xl-8'>
            <Panel>
              <Panel.Header>
                Updates
              </Panel.Header>
              <Panel.Body>
                <ul className='list-group list-group-flush'>
                  {renderRows()}
                </ul>
                {!showMoreVisible ? null : (
                  <div className='mt-3'>
                    <Inputs.Button variant='hover-default' block label='Show More' iconClass='icons8-down-arrow' />
                  </div>
                )}
              </Panel.Body>
            </Panel>
          </div>
        </div>
      </Flow.Body>
    </Flow>
  );
}

function MenuUpdateRow(item, index, history) {
  const renderPendingChildCount = () => {
    const count = item.activeChildCount - item.successfulChildCount - item.failedChildCount - item.progressChildCount;
    if (count === 0) return null;
    return (
      <FlexibleRow.Column>
        <span className='badge badge-light-primary badge-md'>Pending ({count})</span>
      </FlexibleRow.Column>
    );
  };

  const renderProgressChildCount = () => {
    const count = item.progressChildCount;
    if (count === 0) return null;
    return (
      <FlexibleRow.Column>
        <span className='badge badge-light-secondary badge-md'>In Progress ({count})</span>
      </FlexibleRow.Column>
    );
  };

  const renderSuccessfulChildCount = () => {
    const count = item.successfulChildCount;
    if (count === 0) return null;
    return (
      <FlexibleRow.Column>
        <span className='badge badge-light-success badge-md'>Successful ({count})</span>
      </FlexibleRow.Column>
    );
  };

  const renderFailureChildCount = () => {
    const count = item.failedChildCount;
    if (count === 0) return null;
    return (
      <FlexibleRow.Column>
        <span className='badge badge-light-danger badge-md'>Failed ({count})</span>
      </FlexibleRow.Column>
    );
  };

  const renderUpdateDateTime = () => {
    if (item.distributeOnHold)
      return 'On Hold';
    else
      return moment(item.distributeDateTime).format('ddd M/D/YY') + ' ' + (item.distributeAsap ? 'ASAP' : moment(item.distributeDateTime).format('h:mma'));
  }

  return (
    <a href={`/MenuUpdate/${item.menuUpdateId}`} className='list-group-item list-group-item-action' key={index}>
      <FlexibleRow>
        <FlexibleRow.Stackable width='10%' minWidth='44px'>
          <FlexibleRow.Column className='px-0'>
            <div className='d-flex justify-content-center align-items-center rounded text-white' style={{ height: 32, width: 32, fontSize: 24, lineHeight: 1, backgroundColor: 'lightblue' }}>
              {item.statusId}
            </div>
          </FlexibleRow.Column>
        </FlexibleRow.Stackable>
        <FlexibleRow.Stackable at='xl' width='65%'>
          <FlexibleRow.Stackable at='sm' width='34%'>
            <FlexibleRow.Column className='premier'>
              {item.menuUpdateName}
            </FlexibleRow.Column>
          </FlexibleRow.Stackable>
          <FlexibleRow.Stackable at='sm' width='66%'>
            <FlexibleRow.Column width='50%'>
              ??
            </FlexibleRow.Column>
            <FlexibleRow.Column width='50%' className='subtle'>
              {renderUpdateDateTime()}
            </FlexibleRow.Column>
          </FlexibleRow.Stackable>
        </FlexibleRow.Stackable>
        <FlexibleRow.Stackable at='lg' width='25%' minWidth='100px' className='text-right' wrap={true}>
          {renderPendingChildCount()}
          {renderProgressChildCount()}
          {renderSuccessfulChildCount()}
          {renderFailureChildCount()}
        </FlexibleRow.Stackable>
      </FlexibleRow>
    </a>
  );
}